"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPageWidgetViewState = void 0;
var ProductPageWidgetViewState;
(function (ProductPageWidgetViewState) {
    ProductPageWidgetViewState["DEFAULT"] = "default";
    ProductPageWidgetViewState["STICKY_DRAWER_OPEN"] = "sticky-drawer-open";
})(ProductPageWidgetViewState = exports.ProductPageWidgetViewState || (exports.ProductPageWidgetViewState = {}));
//# sourceMappingURL=productPageWidgetViewState.js.map